export default __webpack_public_path__ + "static/media/illustra-onboarding-2.09ec57b6.png";